module.exports = __webpack_public_path__ + "static/media/darkAlert.d172e9e3.svg";